import { AnalyticsEvent, fireGtmEvent } from 'src/utils/new-analytics';

interface RecommendationFeedbackContext {
  buyerId: string;
  listingId: string;
}

export const recommendationFeedback = {
  relevant(context: RecommendationFeedbackContext) {
    fireGtmEvent(AnalyticsEvent.RecommendationRelevantYes, context);
  },
  irrelevant(context: RecommendationFeedbackContext) {
    fireGtmEvent(AnalyticsEvent.RecommendationRelevantNo, context);
  },
};
